import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DatetimeQuestion } from '../../../classes/question-datetime';

@Component({
  selector: 'bepatient-input-datetime',
  templateUrl: './input-datetime.component.html',
  styleUrls: ['./input-datetime.component.scss'],
  standalone: false
})
export class InputDatetimeComponent {
  private dateDatetimeQuestion;

  @Input() parent: UntypedFormGroup;
  @Input()
  set question(question: DatetimeQuestion) {
    this.dateDatetimeQuestion = question;
    this.parent.patchValue({ datetime: question['defaultDate'] });
  }
  get question() {
    return this.dateDatetimeQuestion;
  }
}
